import { toast } from 'react-toastify';

const showCustomToast = (message, type, options) => {
  toast[type](message, options);
};

export default showCustomToast;
